import React from 'react';
import { Box, styled, useMediaQuery } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  background: theme.palette.misc.background,
}));

const FullPageTemplate: React.FC = ({ children, ...props }) => {
  const isCardLayout = useMediaQuery('(min-width:1600px)');

  return (
    <StyledBox pb={isCardLayout ? 2 : 0} {...props}>
      {children}
    </StyledBox>
  );
};

export default FullPageTemplate;
